var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-message-wrapper"},[(_vm.welcomeMessageText?.length)?_c('Notify',{style:(`${_vm.notification.enabled ? 'margin-top: 15px; ' : ''}`),domProps:{"innerHTML":_vm._s(_vm.welcomeMessageText)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }